import routeConfig from './config/routerConfig'

export default [
  {
    path: routeConfig.shopDetail,
    name: 'shopDetail',
    async component(resolve) {
      resolve(
        await import(
          /* webpackChunkName: 'shop' */
          '@/pages/shopDetail/index'
        ),
      )
    },
  },
  {
    path: routeConfig.bizoppDetail,
    name: 'bizoppDetail',
    redirect: '/v2/bizopp-detail',
    async component(resolve) {
      resolve(
        await import(
          /* webpackChunkName: 'BizoppDetailV2' */
          '@/pages-v2/ShopDetail/bizoppV2.vue'
        ),
      )
    },
  },
  {
    path: routeConfig.shopDetailMapView,
    name: 'mapView',
    async component(resolve) {
      resolve(
        await import(
          /* webpackChunkName: 'mapvied' */
          '@/pages/shopDetail/pages/mapView'
        ),
      )
    },
  },
  {
    path: routeConfig.shopDetailBaseDetail,
    name: 'shopBaseDetail',
    async component(resolve) {
      resolve(
        await import(
          /* webpackChunkName: 'shopBaseDetail' */
          '@/pages/shopDetail/pages/shopBaseDetail'
        ),
      )
    },
  },
  {
    path: routeConfig.shopDetailList + ':page',
    async component(resolve) {
      resolve(
        await import(
          /* webpackChunkName: 'list' */
          '@/pages/shopDetail/pages/list'
        ),
      )
    },
  },
  {
    path: routeConfig.shopDetailGallery,
    async component(resolve) {
      resolve(
        await import(
          /* webpackChunkName: 'gallery' */
          '@/pages/shopDetail/pages/gallery'
        ),
      )
    },
  },
  {
    path: routeConfig.shopDetailListDetail + ':page',
    async component(resolve) {
      resolve(
        await import(
          /* webpackChunkName: 'listDetailPage' */
          '@/pages/shopDetail/pages/listDetailPage'
        ),
      )
    },
  },
  {
    path: routeConfig.salesData,
    name: 'salesData',
    async component(resolve) {
      resolve(
        await import(
          /* webpackChunkName: 'shop' */
          '@/pages/shopDetail/pages/saleData'
        ),
      )
    },
  },
]
